import { ComputedRef } from 'vue';
import { ActionButtonStyle } from '../lib/Types/Types';

export enum ToolbarSize {
    regular,
    large,
    small
}

export enum ToolbarStyle {
    outline,
    solidBlue
}

export enum ToolbarBackground {
    white = "background-isalus-white",
    transparent = "bg-transparent",
    iSalusBlue = "background-isalus-primary"
}

export enum ToolbarPadding {
    paddingAll,
    paddingOnlyLeftRight
}

export type IToolbarItemTypes = IToolbarItem | IToolbarActionButtonItem | IToolbarDropDownButton | IToolbarSearchActionItem;
export interface IToolbar {
    toolbarList: IToolbarItemTypes[],
}

export enum ToolbarItemType {
    search,
    div,
    actionButton
}

export interface IToolbarItem {
    identifier?: number | string,
    label?: string,
    width?: number,
    action?: ActionButtonStyle,
    tooltip?: string,
    enabled?: boolean,
    search?: IToolbarSearchItem,
    hidden?: boolean,
    buttonClass?: string,
    toolBarItemType?: ToolbarItemType,
    toolbarClass?: string
}

// Toolbar button item
export interface IToolbarActionButtonItem extends IToolbarItem {
    performAction: (contextValue?: string | number) => Promise<void>    // Action event to perform (show spinner & disable)
}

// Toolbar dropdown button item
export interface IToolbarDropDownButton extends IToolbarItem {
    onMouseEnterClass?: string,
    buttonGroupClass?: string,
    baseClass?: string,
    menuList: IToolbarDropDownMenuItem[] | IToolbarDropDownMenuActionItem[]
}

export interface IToolbarDivItem extends IToolbarItem {
    divContent?: ComputedRef<string> | string;
    onMouseEnterClass?: string,
    baseClass?: string,
    performAction?: (contextValue?: string | number) => Promise<void>    // Action event to perform 
}

// Toolbar search input item
export interface IToolbarSearchActionItem extends IToolbarItem {
    searchAction: (data: string|number|undefined, searchResult: string|undefined, forceNewSearch?:boolean) => Promise<void>
}

export interface IToolbarDropDownMenuItem {
    identifier: number | string,
    label: string,
    enabled?: boolean,
}

export interface IToolbarDropDownMenuActionItem extends IToolbarDropDownMenuItem {
    performAction: (contextValue?: string | number) => Promise<void>    // Action event to perform (show spinner & disable)
}

export interface IToolbarSearchItem {
    keyPressDelay: boolean,
    maxLength?: number,
    placeholder?: string,
    searchText?: string,
    onfocus?: () => void,       // Search field has focus
    onblur?: () => void    // Search field lost focus
}


